import { observable, action } from 'mobx';
import stores from 'cd-eft/models/Stores';

const setStore = stores.AppStore.surveyEngineeringStore;

export class AlignmentVM {
  @observable props;
  currentObject;

  constructor(props: any) {
    this.props = props;
    this.currentObject = setStore.stationOffsetObject;
    this.refillPlotData();
  }

  // for graph
  @observable plotData = {};
  @observable targetDivID = 'so-graph-div';
  @observable windowOptions = {
    margins: { top: 10, right: 60, bottom: 40, left: 60 },
    height: 450,
    axis: { x: 'Distance (ft)', y: 'Elevation (ft)' },
    curveType: 'curveLinear',
    ariaLabelForLines: [' peak elevation is ', ' feet at ', ' distance feet'],
    ariaLabel: 'Graph of survey profile showing elevation on the y axis and distance on the x axis.',
  };
  //

  @action.bound setBeginningX(e: any) {
    this.currentObject.beginningX = e.target.value;
    this.currentObject.alignmentStations.forEach((el) => (el.x = Number(e.target.value)));
  }

  @action.bound setBeginningY(e: any) {
    this.currentObject.beginningY = e.target.value;
    this.currentObject.alignmentStations.forEach((el) => (el.y = Number(e.target.value) + Number(el.stationDistance)));
  }

  // update AlignmentStations in Store
  @action.bound updateSingleAlignmentStation(e: any) {
    const value = e.target.value;
    const name = e.target.name;
    const index = e.target.getAttribute('data-i');
    this.currentObject.alignmentStations[index][name] = +value;
  }

  @action.bound setBeginningStation(e: any) {
    this.currentObject.alignmentStations[0].stationDistance = e.target.value;
    this.currentObject.alignmentStations[0].stationName = Math.round(e.target.value);
    if (this.currentObject.offsetStations) {
      this.currentObject.offsetStations[0].stationDistance = e.target.value;
    }
    if (this.currentObject.crossSlopeStations) {
      this.currentObject.crossSlopeStations[0].stationDistance = e.target.value;
    }
  }

  @action.bound refillPlotData() {
    const stationName = `Alignment profile`;
    this.plotData = {};
    this.plotData[stationName] = [];
    if (this.currentObject.offsetStations) {
      this.currentObject.offsetStations.map((el) =>
        this.plotData[stationName].push([
          el.stationDistance,
          el.entryMode === 'ROD' ? el.hiElevation - el.offsets[1].z : el.offsets[1].z,
        ])
      );
    }
    if (this.currentObject.crossSlopeStations) {
      this.currentObject.crossSlopeStations.map((el) =>
        this.plotData[stationName].push([
          el.stationDistance,
          el.offsetType === 'TYPE_ROD'
            ? el.hiElevation - el.crossSlopeStationOffsets[0].z
            : el.crossSlopeStationOffsets[0].z,
        ])
      );
    }
  }

  @action.bound someAction(e: any) {
    e.preventDefault();
  }
}
